<template>
  <div class="table-idp-activities">
    <div class="adp-grid-row adp-grid-row__employee_idp_wishes">
      <div class="adp-grid-cell adp-grid-cell__chbox">
        <b-form-checkbox v-model="selectAll" :indeterminate="selectAllIndeterminate" @change="selectAllHandler($event)">&nbsp;</b-form-checkbox>
      </div>
      <div class="d-flex flex-column adp-grid-cell__head">
        <span class="adp-th adp-th__sort" :class="{'adp-th__active': sortingName !== null}" @click="sortChange('sortingName')">
          {{ $t('catalog.name') }} <img :src="getSortingIcon(sortingName)" alt="sort">
        </span>
        <input @input="filterAndSortItems" type="text" class="adp-input adp-input__catalog adp-input-search" v-model="filterName">
      </div>
      <div class="d-flex flex-column adp-grid-cell__head">
        <span class="adp-th adp-th__sort" :class="{'adp-th__active': sortingAuthor !== null}" @click="sortChange('sortingAuthor')">
          {{ $t('voc.table_author') }} <img :src="getSortingIcon(sortingAuthor)" alt="sort">
        </span>
        <my-dropdown :options="authors" :init-selected="filterAuthors" :has-select-all="true"
                     v-on:my-change="onDropdownUpdate($event, 'filterAuthors')" :localize="false">
        </my-dropdown>
      </div>
      <div class="d-flex flex-column adp-grid-cell__head">
        <span class="adp-th adp-th__sort" :class="{'adp-th__active': sortingStatus !== null}" @click="sortChange('sortingStatus')">
          {{ $t('voc.table_status') }} <img :src="getSortingIcon(sortingStatus)" alt="sort">
        </span>
        <my-dropdown :options="statuses" :init-selected="filterStatuses" :has-select-all="true"
                     v-on:my-change="onDropdownUpdate($event, 'filterStatuses')">
        </my-dropdown>
      </div>
    </div >

    <div class="adp-grid-row adp-grid-row__employee_idp_wishes" v-for="(item, i) in items" :key="i"
         style="cursor: pointer" @click="$emit('learning-click', item)">
      <div class="adp-grid-cell adp-grid-cell__chbox-hr" @click.stop>
        <b-form-checkbox v-model="item.is_checked" @change="selectEvent" @click.stop/>
      </div>
      <div class="adp-grid-cell adp-grid-cell__title">
        {{ item.name }}
      </div>
      <div class="adp-grid-cell adp-grid-cell__title">
        {{ role === item.author_role ? $t('modal.created_by_you') : $t(`modal.created_by_${item.author_role}`) }}
      </div>
      <div class="adp-grid-cell adp-grid-cell__title" :style="`color: ${textColor(item.status)}`">
        <div style="width: 65%">{{ item.status === 'assigned' ? $t(`idp.assigned_for_wish`) : $t(`idp.${item.status}`) }}</div>
        <div class="d-flex flex-column">
          <div v-if="item.files.length" style="cursor: pointer; display: flex"
               @click="$emit('show-files-modal', item.files, item.name, item.id)"
          >
            <img src="/images/paperclip.svg" style="height: 25px" alt="" v-if="isAllFilesViewed(item.files)">
            <img src="/images/paperclip-yellow.svg" v-else style="width: 24px" alt="">
            <span :style="isAllFilesViewed(item.files) ? 'color: #234B85' : 'color: #E6C600'">
              {{ item.files.length }}
            </span>
          </div>
          <div v-if="item.comments.length" style="cursor: pointer; display: flex"
               @click.stop="$emit('show-comments-modal', item.comments, item.name, item.id)"
          >
            <img src="/images/comment.svg" style="height: 25px" alt="" v-if="isAllCommentsRead(item.comments)">
            <img src="/images/comment-yellow.svg" v-else alt="">
            <span :style="isAllCommentsRead(item.comments) ? 'color: #234B85' : 'color: #E6C600'">
              {{ item.comments.length }}
            </span>
          </div>
        </div>
        <div style="padding: 0 8px; cursor: pointer" @click.stop="$emit('click-dots', $event, IDP.id, item)" v-if="role !== 'admin'">
          <img src="/images/vertical_dots.svg" alt="">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MyDropdown from "./MyDropdown";
import {updateUrl} from "../updateUrl";

export default {
  name: "EmployeeTableIDPWishes",
  components: {
    'my-dropdown': MyDropdown,
  },
  props: {
    vals: {
      type: Array,
      required: true
    },
  },
  data: () => {
    return {
      role: '',

      items: [],
      assignItems: {},

      selectAll: false,
      selectAllIndeterminate: false,

      isActiveCompetence: false,

      sortingName: null,
      sortingAuthor: null,
      sortingStatus: null,

      filterName: '',
      filterAuthors: [],
      filterStatuses: [],

      authors: [],
      statuses: [],
    }
  },
  watch: {
    filterName(newVal) {
      this.updateUrl({filterName: newVal && newVal.length ? String(newVal) : null});
    },
    filterAuthors(newVal) {
      this.updateUrl({filterAuthors: newVal && newVal.length ? String(newVal) : null});
    },
    filterStatuses(newVal) {
      this.updateUrl({filterStatuses: newVal && newVal.length ? String(newVal) : null});
    },
  },
  computed: {

  },
  methods: {
    isAllFilesViewed(files) {
      const notAllFilesViewed = files.find(file => file.is_viewed === false)
      return !notAllFilesViewed;
    },
    isAllCommentsRead(comments) {
      const notAllCommentsRead = comments.find(comment => comment.is_read === false);
      return !notAllCommentsRead;
    },
    updateUrl(params) {
      updateUrl(params);
    },
    filterAndSortItems() {
      function dynamicSort(property) {
        let sortOrder = 1;
        if (property[0] === "-") {
          sortOrder = -1;
          property = property.substr(1);
        }
        return function (a, b) {
          let result = (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0;
          return result * sortOrder;
        }
      }

      let items = this.vals;

      if (this.filterName) {
        this.filterName.length > 0
          ? items = items.filter(el => {
            return String(el.name).toLowerCase().includes(this.filterName)
              || String(el.name).includes(this.filterName)
          })
          : items = items.filter(el => el.name);
      }
      if (this.filterAuthors.length > 0) {
        items = items.filter(el => this.filterAuthors.includes(el.author_role));
      }
      if (this.filterStatuses.length > 0) {
        items = items.filter(el => this.filterStatuses.includes(el.status));
      }

      // возвращаем сортировку в исходное положение(сортируем по id)
      items = items.sort(dynamicSort('id'));

      if (this.sortingName) {
        let co = this.sortingName === 'desc' ? '-' : '';
        items = items.sort(dynamicSort(`${co}name`));
      } else if (this.sortingAuthor) {
        let co = this.sortingAuthor === 'desc' ? '-' : '';
        items = items.sort(dynamicSort(`${co}author_role`));
      } else if (this.sortingStatus) {
        let co = this.sortingStatus === 'desc' ? '-' : '';
        items = items.sort(dynamicSort(`${co}status`));
      }

      items.forEach(el => el.is_checked = false);
      this.items = JSON.parse(JSON.stringify(items));
    },
    sortChange(prop) {
      if (this[prop] === null) {
        this[prop] = 'asc';
      } else if (this[prop] === 'asc') {
        this[prop] = 'desc';
      } else if (this[prop] === 'desc') {
        this[prop] = null;
      }

      ['sortingName', 'sortingAuthor', 'sortingStatus']
        .forEach(el => {
          if (el === prop) {
            this.updateUrl({[el]: this[prop]})
            return;
          }
          if (this[el]) {
            this[el] = null;
            this.updateUrl({[el]: null})
          }
      });

      this.filterAndSortItems();
    },
    getSortingIcon(val) {
      if (val === null) {
        return '/images/sort.svg';
      } else if (val === 'asc') {
        return '/images/sort_active_asc.svg';
      } else if (val === 'desc') {
        return '/images/sort_active_desc.svg';
      }
    },
    onDropdownUpdate(e, property) {
      this[property] = e;
      this.filterAndSortItems();
    },
    hide(prop) {
      this[prop] = false;
    },
    selectAllHandler(event) {
      if (Object.keys(this.assignItems).length) {
        this.items = this.items.map(el => {el.is_checked = false; return el});
        this.selectAll = false;
      } else {
        this.items = this.items.map(el => {el.is_checked = true; return el});
        this.selectAll = true;
      }
      this.selectAllIndeterminate = false;
      this.updateItemsChecked();
    },
    updateItemsChecked() {
      let items = {};
      let assignedItems = this.items.filter(el => el.is_checked).map(el => ({ ...el }));

      assignedItems.forEach(item => {
        items[item.id] = item
      })

      this.assignItems = items;
      this.$emit('changeWishAssignItems', items);
    },
    selectEvent() {
      let checkedElementsCnt = this.items.filter(el => el.is_checked).length;
      if (this.items.length === checkedElementsCnt) {
        this.selectAll = true;
        this.selectAllIndeterminate = false;
      } else if (this.items.length > checkedElementsCnt && checkedElementsCnt > 0) {
        this.selectAll = false;
        this.selectAllIndeterminate = true;
      } else {
        this.selectAll = false;
        this.selectAllIndeterminate = false;
      }

      this.updateItemsChecked();
    },
    textColor(status) {
      if (status === 'draft') return '#6D7278';
      if (status === 'done') return '#509A01';
      if (status === 'rejected') return '#E02020';
      return '#E6C600';
    },
  },
  mounted() {
    this.role = window.IDP.role;

    // Init available filter options
    let statusesArr = window.IDP.learningActivityStatuses;
    for (let code of statusesArr) {
      if (code === 'assigned' || code === 'draft' || code === 'rejected') {
        this.statuses.push({id: code, code: code,});
      }
      this.statuses.map(status => {
        if (status.id === 'assigned') status.wish = true;
      });
    }

    this.authors = [
      {id: 'hr', code: this.$t('modal.created_by_hr')},
      {id: 'manager', code: this.$t('modal.created_by_manager')},
      {id: 'employee', code: this.$t('modal.created_by_employee')}
    ];
    this.authors.map(author => {
      if (this.role === author.id) author.code = this.$t('modal.created_by_you')
    })

    // Init selected filter values
    let currState = Object.fromEntries(new URLSearchParams(window.location.search));

    if (currState.filterName) {
      this.filterName = String(currState.filterName);
    }

    if (currState.filterAuthors) {
      let filterAuthors = currState.filterAuthors.split('0');
      filterAuthors = filterAuthors.filter(author => authorsArr.includes(author));
      this.filterAuthors.splice(0, this.filterAuthors.length, ...filterAuthors);
    }

    if (currState.filterStatuses) {
      let filterStatuses = currState.filterStatuses.split('0');
      filterStatuses = filterStatuses.filter(status => statusesArr.includes(status));
      this.filterStatuses.splice(0, this.filterStatuses.length, ...filterStatuses);
    }

    ['sortingName', 'sortingAuthor', 'sortingStatus']
      .forEach(el => {
        if (currState[el] && (currState[el] === 'asc' || currState[el] === 'desc')) {
          this[el] = currState[el];
        }
      });

    this.filterAndSortItems();
  }
}
</script>

<style scoped>

</style>
